// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"443":"about","573":"party"}[chunkId] || chunkId) + "." + {"139":"f1f48cf1","443":"7927df1c","573":"17c903ce"}[chunkId] + ".js";
};